import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import BasicClumn from '../../../graphics/BasicColumnPlot';
import { Title } from './styles';

const BasicColumn: React.FC = () => {
  const [data, setData] = React.useState<any>([]);
  const dataState = useSelector(
    (state: ApplicationState) => state?.DashSla?.data['solicitacaoMes']
  );

  const dataFilter = dataState?.map((item: any) => {
    return {
      type: item.mes,
      sales: item.valor,
      percentual: item.percentual,
    };
  });

  React.useEffect(() => {
    dataState?.length > 0 ? setData(dataFilter) : setData([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataState]);
  return (
    <>
      <Title>Atendimento por mês</Title>
      <div style={{ width: '100%', padding: '10px' }}>
        <BasicClumn data={data} />
      </div>
    </>
  );
};

export default BasicColumn;
